export default __webpack_public_path__ + "static/media/img_desk3.9aa39444.svg";